/* =======================================================
   SnooozeCo — Product Page JS
   Accordion for Description, Inventory Glow,
   Ultra-fast lightbox + panzoom + instant thumb switching
======================================================= */

/* -------------------------------------------------------
   1. Accordion
------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", setupAccordions);
document.addEventListener("shopify:section:load", setupAccordions);

function setupAccordions() {
  const rows = document.querySelectorAll(".product__accordion-row");
  if (!rows.length) return;

  rows.forEach((row) => {
    const summary = row.querySelector(".product__accordion-summary");
    const content = row.querySelector(".product__accordion-content");

    if (!summary || !content) return;

    // RESET max-height so the animation works
    if (row.classList.contains("open")) {
      content.style.maxHeight = content.scrollHeight + "px";
    } else {
      content.style.maxHeight = "0px";
    }

    // Remove pre-existing listeners in a safe way
    summary.addEventListener("click", (e) => {
      e.stopImmediatePropagation(); // prevents stacking

      const isOpen = row.classList.contains("open");

      // Close all rows
      rows.forEach((other) => {
        if (other !== row) collapse(other);
      });

      // Toggle clicked row correctly
      if (isOpen) {
        collapse(row);
      } else {
        expand(row);
      }
    });
  });
}

function expand(row) {
  const content = row.querySelector(".product__accordion-content");
  if (!content) return;

  row.classList.add("open");
  content.style.maxHeight = content.scrollHeight + "px";
}

function collapse(row) {
  const content = row.querySelector(".product__accordion-content");
  if (!content) return;

  row.classList.remove("open");
  content.style.maxHeight = "0px";
}


document.addEventListener("DOMContentLoaded", () => {
  const grid = document.querySelector(".pairs-grid.pairs-swipe");
  if (!grid) return;

  let timeout;

  grid.addEventListener("scroll", () => {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      const items = [...grid.querySelectorAll(".pairs-item")];
      if (!items.length) return;

      const itemWidth = items[0].offsetWidth + 16; // plus gap
      const index = Math.round(grid.scrollLeft / itemWidth);

      grid.scrollTo({
        left: index * itemWidth,
        behavior: "smooth"
      });
    }, 120);
  });
});

/* -------------------------------------------------------
   2. Minor widgets
------------------------------------------------------- */
const SnooozeInventory = { init() {} };

const SnooozePairsSwipe = {
  init() {
    const c = document.querySelector(".pairs-grid.pairs-swipe");
    if (!c) return;

    c.addEventListener("wheel", (e) => {
      e.preventDefault();
      c.scrollLeft += e.deltaY;
    });
  },
};

const SnooozeRelated = {
  init() {
    const track = document.querySelector(".related-slider__track");
    if (!track) return;

    let sx = 0;
    track.addEventListener("touchstart", (e) => (sx = e.touches[0].clientX));
    track.addEventListener(
      "touchmove",
      (e) => (track.scrollLeft += (sx - e.touches[0].clientX) * 0.8)
    );
  },
};

(function () {
  const body = document.body;

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-size-guide-open]');
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();

    const lightbox = document.querySelector('[data-size-guide-lightbox]');
    if (!lightbox) {
      console.warn('Size guide lightbox not found');
      return;
    }

    lightbox.classList.add('lightbox--active');
    lightbox.setAttribute('aria-hidden', 'false');
    body.style.overflow = 'hidden';
  });

  document.addEventListener('click', function (e) {
    if (
      e.target.closest('[data-size-guide-close]') ||
      e.target === document.querySelector('[data-size-guide-lightbox]')
    ) {
      const lightbox = document.querySelector('[data-size-guide-lightbox]');
      if (!lightbox) return;

      lightbox.classList.remove('lightbox--active');
      lightbox.setAttribute('aria-hidden', 'true');
      body.style.overflow = '';
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;

    const lightbox = document.querySelector('[data-size-guide-lightbox]');
    if (!lightbox || !lightbox.classList.contains('lightbox--active')) return;

    lightbox.classList.remove('lightbox--active');
    lightbox.setAttribute('aria-hidden', 'true');
    body.style.overflow = '';
  });
})();


/* -------------------------------------------------------
   Initialize everything
   ------------------------------------------------------- */
function initProductScripts() {
  SnooozeProductAccordion.init();
  SnooozeInventory.init();
  SnooozePairsSwipe.init();
  SnooozeRelated.init();
}

document.addEventListener("DOMContentLoaded", initProductScripts);
document.addEventListener("shopify:section:load", initProductScripts);
